var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._b({},'v-card',_vm.$attrs,false),[_c('v-card-title',{staticClass:"primary darken-1 white--text"},[_c('v-icon',{attrs:{"left":"","color":"white"}},[_vm._v("mdi-account-tie")]),_vm._t("title",function(){return [_vm._v("Información del Vendedor")]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }